"use client";
import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Box, IconButton, List, ListItem, ListItemText, Paper, Chip, Dialog, DialogTitle, DialogContent, Typography, Button, TextField, MenuItem, Grid, Autocomplete, Slider, IconButton as MuiIconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download'; // New import for the download button
import InputBase from '@mui/material/InputBase';
import { useRecoilState } from 'recoil';
import { filterState } from './filterState';

// Court options loaded from the XLS file
const courtOptions = [
  { Tiesa: 'Administratīvā apgabaltiesa', Kods: 'ADAT' },
  { Tiesa: 'Administratīvā rajona tiesa Jelgavas tiesu nams', Kods: 'ADRJJTN' },
  { Tiesa: 'Administratīvā rajona tiesa Liepājas tiesu nams', Kods: 'ADRJLTN' },
  { Tiesa: 'Administratīvā rajona tiesa Rēzeknes tiesu nams', Kods: 'ADRJRTN' },
  { Tiesa: 'Administratīvā rajona tiesa Rīgas tiesu nams', Kods: 'ADRJRIT' },
  { Tiesa: 'Administratīvā rajona tiesa Valmieras tiesu nams', Kods: 'ADRJVTN' },
  { Tiesa: 'Aizkraukles rajona tiesa', Kods: 'AIRT' },
  { Tiesa: 'Alūksnes rajona tiesa', Kods: 'ALRT' },
  { Tiesa: 'Augstākās tiesas Senāts', Kods: 'AT' },
  { Tiesa: 'Bauskas rajona tiesa', Kods: 'BSRT' },
  { Tiesa: 'Cēsu rajona tiesa', Kods: 'CERT' },
  { Tiesa: 'Daugavpils tiesa', Kods: 'DAUT' },
  { Tiesa: 'Dobeles rajona tiesa', Kods: 'DORT' },
  { Tiesa: 'Ekonomisko lietu tiesa', Kods: 'ELT' },
  { Tiesa: 'Gulbenes rajona tiesa', Kods: 'GURT' },
  { Tiesa: 'Jēkabpils rajona tiesa', Kods: 'JERT' },
  { Tiesa: 'Jelgavas tiesa', Kods: 'JELT' },
  { Tiesa: 'Kuldīgas rajona tiesa', Kods: 'KURT' },
  { Tiesa: 'Kurzemes apgabaltiesa', Kods: 'KUAT' },
  { Tiesa: 'Latgales apgabaltiesa', Kods: 'LAAT' },
  { Tiesa: 'Latgales rajona tiesa', Kods: 'LRT' },
  { Tiesa: 'Liepājas tiesa', Kods: 'LIET' },
  { Tiesa: 'Limbažu rajona tiesa', Kods: 'LIRT' },
  { Tiesa: 'Madonas rajona tiesa', Kods: 'MART' },
  { Tiesa: 'Ogres rajona tiesa', Kods: 'OGRT' },
  { Tiesa: 'Rēzeknes tiesa', Kods: 'REZT' },
  { Tiesa: 'Rīgas apgabaltiesa', Kods: 'RAT' },
  { Tiesa: 'Rīgas pilsētas Latgales priekšpilsētas tiesa', Kods: 'RLPT' },
  { Tiesa: 'Rīgas pilsētas Pārdaugavas tiesa', Kods: 'RPPT' },
  { Tiesa: 'Rīgas pilsētas tiesa', Kods: 'RPT' },
  { Tiesa: 'Rīgas pilsētas Vidzemes priekšpilsētas tiesa', Kods: 'RVPT' },
  { Tiesa: 'Rīgas pilsētas Ziemeļu rajona tiesa', Kods: 'RZRT' },
  { Tiesa: 'Rīgas rajona tiesa', Kods: 'RIRT' },
  { Tiesa: 'Rīgas rajona tiesa Jūrmalas tiesu nams', Kods: 'RIRTJ' },
  { Tiesa: 'Saldus rajona tiesa', Kods: 'SART' },
  { Tiesa: 'Talsu rajona tiesa', Kods: 'TART' },
  { Tiesa: 'Tukuma rajona tiesa', Kods: 'TURT' },
  { Tiesa: 'Valkas rajona tiesa', Kods: 'VART' },
  { Tiesa: 'Valmieras rajona tiesa', Kods: 'VLRT' },
  { Tiesa: 'Ventspils tiesa', Kods: 'VENT' },
  { Tiesa: 'Vidzemes apgabaltiesa', Kods: 'VAT' },
  { Tiesa: 'Vidzemes rajona tiesa', Kods: 'VRT' },
  { Tiesa: 'Zemgales apgabaltiesa', Kods: 'ZAT' },
  { Tiesa: 'Zemgales rajona tiesa', Kods: 'ZRT' }
];

function Header({ onSearch }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showHelper, setShowHelper] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [legalActsOptions, setLegalActsOptions] = useState([]);
  const [articleOptions, setArticleOptions] = useState([]);
  const [selectedFilters, setSelectedFilters] = useRecoilState(filterState);

  // Function to handle PDF download
  const handleDownloadPdf = () => {
  const pdfUrl = '/TiesuPrakseLv.pdf'; // This points to the PDF in your public folder
  const link = document.createElement('a');
  link.href = pdfUrl;
  link.download = 'TiesuPrakseLv.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  useEffect(() => {
    if (openFilterDialog && legalActsOptions.length === 0) {
      fetch('https://iids8vsrw0.execute-api.eu-north-1.amazonaws.com/test/ta-get-lists?type=2')
        .then((response) => response.json())
        .then((data) => {
          setLegalActsOptions(data);
        })
        .catch((error) => {
          console.error('Error fetching legal acts for autocomplete:', error);
        });
    }
  }, [openFilterDialog, legalActsOptions.length]);

  const handleAutocompleteChange = (index, name, newValue) => {
    const updatedFilters = [...selectedFilters.likumaAtsauces];
    if (name === 'likumaAtsauceStart' && newValue) {
      const selectedLegalAct = legalActsOptions.find(option => option.title === newValue);
      updatedFilters[index] = {
        ...updatedFilters[index],
        [name]: newValue,
        legal_act_id: selectedLegalAct?.legal_act_id || null,
      };
      if (selectedLegalAct?.legal_act_id) {
        fetch(`https://iids8vsrw0.execute-api.eu-north-1.amazonaws.com/test/ta-get-lists?type=3&legal_act_id=${selectedLegalAct.legal_act_id}`)
          .then((response) => response.json())
          .then((data) => {
            const updatedArticleOptions = [...articleOptions];
            updatedArticleOptions[index] = data.map(article => ({
              title: article.article_number.toString(),
              article_number: article.article_number,
            }));
            setArticleOptions(updatedArticleOptions);
          })
          .catch((error) => {
            console.error('Error fetching articles for autocomplete:', error);
          });
      }
    } else if (name === 'likumaAtsauceEnd') {
      const selectedArticle = newValue
        ? articleOptions[index]?.find(option => option.title === newValue)
        : null;
      updatedFilters[index] = {
        ...updatedFilters[index],
        [name]: newValue ? newValue.replace(' (undefined)', '') : '',
        article_number: selectedArticle ? selectedArticle.article_number : null,
      };
    } else {
      updatedFilters[index] = {
        ...updatedFilters[index],
        [name]: newValue,
      };
    }
    setSelectedFilters({
      ...selectedFilters,
      likumaAtsauces: updatedFilters,
    });
  };

  const handleSliderChange = (index, event, newValue) => {
    const updatedFilters = selectedFilters.likumaAtsauces.map((filter, i) =>
      i === index ? { ...filter, likumaAtsauceSlider: newValue } : filter
    );
    setSelectedFilters({
      ...selectedFilters,
      likumaAtsauces: updatedFilters,
    });
  };

  const removeLikumaAtsauceFilter = (index) => {
    if (selectedFilters.likumaAtsauces.length > 1) {
      const updatedFilters = selectedFilters.likumaAtsauces.filter((_, i) => i !== index);
      setSelectedFilters({
        ...selectedFilters,
        likumaAtsauces: updatedFilters,
      });
    }
  };

  const handleAddFilter = () => {
    const newFilter = {
      likumaAtsauceStart: '',
      likumaAtsauceEnd: '',
      likumaAtsauceSlider: [0, 100],
    };
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      likumaAtsauces: [...prevFilters.likumaAtsauces, newFilter],
    }));
  };

  const handleSaveFilterPreset = () => {
  const savedPreset = { ...selectedFilters };
  localStorage.setItem('filterPreset', JSON.stringify(savedPreset));
  setOpenFilterDialog(false);

  // Combine the current search query with filters
  const combinedFilters = {
    query: searchQuery, // using your search input state
    filters: { 
      ...selectedFilters,
      tiesasInstance: selectedFilters.tiesasInstance
    },
  };

  // Trigger the search
  onSearch(combinedFilters);
};

  const handleSearchClick = () => {
    const combinedFilters = {
      query: searchQuery,
      filters: { 
        ...selectedFilters,
        tiesasInstance: selectedFilters.tiesasInstance
      },
    };
    onSearch(combinedFilters);
  };

  const handleInputFocus = () => {
    setShowHelper(true);
  };

  const handleInputBlur = () => {
    setTimeout(() => setShowHelper(false), 100);
  };

  const handleCourtChange = (event) => {
    const selectedCourt = courtOptions.find(option => option.Tiesa === event.target.value);
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      tiesa: selectedCourt?.Kods || ''
    }));
  };

  const handleClearFilters = () => {
    setSelectedFilters({
      tiesa: '',
      tiesasInstance: '',
      dokumentaDatumsFrom: '',
      dokumentaDatumsTo: '',
      likumaAtsauces: [
        {
          likumaAtsauceStart: '',
          likumaAtsauceEnd: '',
          likumaAtsauceSlider: [0, 100],
        },
      ],
    });
  };

  return (
    <AppBar position="fixed">
      <Toolbar style={{ justifyContent: 'center', position: 'relative' }}>
        <Box display="flex" alignItems="center" position="relative">
          <Box display="flex" flexDirection="column" alignItems="center" style={{ position: 'relative', width: '400px' }}>
            <InputBase
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              style={{
                backgroundColor: '#424242',
                borderRadius: '4px',
                width: '100%',
                padding: '8px',
                color: '#ffffff',
              }}
            />
            {showHelper && (
              <Paper style={{ position: 'absolute', width: '100%', top: '40px', zIndex: 10 }}>
                <List>
                  <ListItem><ListItemText primary="Use && to search multiple terms" /></ListItem>
                  <ListItem><ListItemText primary="Use || for optional words" /></ListItem>
                  <ListItem><ListItemText primary="Use quotes for exact phrases" /></ListItem>
                </List>
              </Paper>
            )}
          </Box>
          <IconButton color="inherit" onClick={handleSearchClick} style={{ marginLeft: '8px' }}>
            <SearchIcon />
          </IconButton>
          <IconButton color="inherit" onClick={() => setOpenFilterDialog(true)} style={{ marginLeft: '8px' }}>
            <FilterListIcon />
          </IconButton>
        </Box>
        {/* Download PDF button positioned at the right corner */}
        <Box position="absolute" right={16}>
  <Button
    color="inherit"
    onClick={handleDownloadPdf}
    startIcon={<DownloadIcon />}
  >
    Instructions
  </Button>
</Box>
        <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)} maxWidth="md" fullWidth>
          <DialogTitle>Filter Options</DialogTitle>
          <DialogContent>
            <List>
              <ListItem>
                <TextField
                  label="Tiesas instance"
                  select
                  value={selectedFilters.tiesasInstance || ''}
                  onChange={(event) =>
                    setSelectedFilters((prevFilters) => ({
                      ...prevFilters,
                      tiesasInstance: event.target.value,
                    }))
                  }
                  fullWidth
                >
                  <MenuItem value="Pirmā instance">Pirmā instance</MenuItem>
                  <MenuItem value="Apelācijas instance">Apelācijas instance</MenuItem>
                  <MenuItem value="Kasācijas instance">Kasācijas instance</MenuItem>
                </TextField>
              </ListItem>
              <ListItem>
                <TextField
                  label="Tiesa"
                  select
                  value={courtOptions.find(option => option.Kods === selectedFilters.tiesa)?.Tiesa || ''}
                  onChange={handleCourtChange}
                  fullWidth
                >
                  {courtOptions.map((option) => (
                    <MenuItem key={option.Kods} value={option.Tiesa}>
                      {option.Tiesa}
                    </MenuItem>
                  ))}
                </TextField>
              </ListItem>
              <ListItem>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      label="Dokumenta datums no"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      value={selectedFilters.dokumentaDatumsFrom || ''}
                      onChange={(event) => setSelectedFilters({ ...selectedFilters, dokumentaDatumsFrom: event.target.value })}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Dokumenta datums līdz"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      value={selectedFilters.dokumentaDatumsTo || ''}
                      onChange={(event) => setSelectedFilters({ ...selectedFilters, dokumentaDatumsTo: event.target.value })}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Box width="100%">
                  {selectedFilters.likumaAtsauces.map((filter, index) => (
                    <Box key={index} mb={2}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                          <Autocomplete
                            options={legalActsOptions.map(option => option.title)}
                            onChange={(event, newValue) => handleAutocompleteChange(index, 'likumaAtsauceStart', newValue)}
                            value={filter.likumaAtsauceStart || null}
                            renderInput={(params) => (
                              <TextField {...params} label="Likums" fullWidth />
                            )}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Autocomplete
                            options={articleOptions[index]?.map(option => option.title) || []}
                            onChange={(event, newValue) => handleAutocompleteChange(index, 'likumaAtsauceEnd', newValue)}
                            value={filter.likumaAtsauceEnd || null}
                            renderInput={(params) => (
                              <TextField {...params} label="Pants" fullWidth />
                            )}
                          />
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: 'center' }}>
                          {selectedFilters.likumaAtsauces.length > 1 && (
                            <MuiIconButton onClick={() => removeLikumaAtsauceFilter(index)} color="secondary" size="small">
                              <DeleteIcon />
                            </MuiIconButton>
                          )}
                        </Grid>
                        <Grid item xs={3}>
                          <Typography variant="caption" style={{ display: 'block', marginBottom: '-8px' }}>Pozīcija tekstā</Typography>
                          <Slider
                            value={filter.likumaAtsauceSlider}
                            onChange={(event, newValue) => handleSliderChange(index, event, newValue)}
                            valueLabelDisplay="auto"
                            min={0}
                            max={100}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </Box>
              </ListItem>
            </List>
            <Box mt={2} textAlign="right">
              <Button onClick={handleAddFilter} color="primary" startIcon={<AddIcon />} variant="outlined">
                Add Legal Reference
              </Button>
            </Box>
            <Box mt={2} textAlign="right">
              <Button onClick={handleSaveFilterPreset} color="primary" variant="contained">
                Apply Filters
              </Button>
              <Button onClick={handleClearFilters} color="secondary" variant="outlined" style={{ marginRight: '8px' }}>
                Clear Filters
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
